import React from 'react';
type Variant = 'primary' | 'dark' | 'outline' | 'outlineLight';
type Size = 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-semibold tracking-tight transition-[background-color,color,border-color,box-shadow,transform] duration-150 ease-out active:translate-y-px';
const variants: Record<Variant, string> = {
  primary: 'bg-cobalt-700 text-white shadow-sm hover:bg-cobalt-800 hover:shadow-md',
  dark: 'bg-charcoal-900 text-white hover:bg-charcoal-800',
  outline: 'border border-charcoal-300 bg-white text-charcoal-800 hover:border-charcoal-800 hover:bg-charcoal-50',
  outlineLight: 'border border-white/45 bg-white/5 text-white backdrop-blur-sm hover:border-white hover:bg-white/15'
};
const sizes: Record<Size, string> = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-[54px] px-7 text-[15px]'
};
type ButtonLinkProps = {
  href: string;
  variant?: Variant;
  size?: Size;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
};
export function ButtonLink({
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  children
}: ButtonLinkProps) {
  return <a href={href} onClick={onClick} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-267" data-mp="es0oau43sxuw">
      {children}
    </a>;
}
type ButtonProps = {
  type?: 'button' | 'submit';
  variant?: Variant;
  size?: Size;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
};
export function Button({
  type = 'button',
  variant = 'primary',
  size = 'md',
  className = '',
  disabled,
  children
}: ButtonProps) {
  return <button type={type} disabled={disabled} className={`${base} ${variants[variant]} ${sizes[size]} disabled:cursor-not-allowed disabled:opacity-70 ${className}`} data-id="element-268" data-mp="1ccv8vzmqu0hf">
      {children}
    </button>;
}